import React, { useEffect, useState } from "react";
import { getHealth } from "../lib/api";

export default function OfflineBanner() {
    const [offline, setOffline] = useState(false);
    useEffect(() => {
        let failures = 0;
        const check = async () => {
            try {
                const h = await getHealth();
                if (h.status === "ok") { failures = 0; setOffline(false); }
                else { failures += 1; if (failures >= 2) setOffline(true); }
            } catch {
                failures += 1;
                if (failures >= 2) setOffline(true);
            }
        };
        check();
        const id = setInterval(check, 20000);
        return () => clearInterval(id);
    }, []);
    if (!offline) return null;
    return (
        <div className="fixed top-0 inset-x-0 z-[110] bg-red-500/95 text-void py-1.5 text-center font-mono text-[11px] uppercase tracking-[0.3em]" data-testid="offline-banner">
            <span className="inline-block w-1.5 h-1.5 bg-void mr-2 align-middle animate-pulse" />
            Signal degraded — backbone heartbeat lost
        </div>
    );
}
